import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import useUserParams from "../hooks/useUserParams";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import pageSEO from "../constants/pageSEO";
import SEO from "./seo.component";

export default function About() {
  const { getAllUserParams } = useUserParams();
  const {
    agentName,
    agentTitle,
    agentNumber,
    agentEmail,
    brokerage,
    about,
    headshot
  } = getAllUserParams();
  const seoConfig = pageSEO.about();
  const aboutContent = about || constants.FULL_ABOUT;

  return (
    <>
      <SEO {...seoConfig} />
      <div className="bg-logo-main">
        <div className="max-w-[1100px] mx-auto gap-x-20 gap-y-10 px-6 grid sm:grid-cols-2 pb-12 min-h-[70vh] pt-[150px] min-[1100px]:pt-[200px]">
          <div>
            <img src={headshot} className="w-full rounded-2xl" />
            <div className="flex flex-col gap-y-2 text-black mt-6">
              <h2 className="text-black libre text-unset text-3xl pb-2">
                {agentName}
              </h2>
              {/* <p className="italic text-lg">{agentTitle}, {brokerage}</p> */}

              <div className="flex gap-x-5 my-2">
                {Object.entries(constants.SOCIALS ?? {})?.map(
                  ([k, v], index) => (
                    <a href={constants.SOCIALS[k]}>
                      <FontAwesomeIcon
                        className="fa-xl text-logo-second"
                        icon={constants.ICONS[k]}
                      />
                    </a>
                  )
                )}
              </div>
              <p className="font-semibold text-lg">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pr-2 text-logo-second"
                />
                {agentNumber}{" "}
              </p>
              <p className="text-lg">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="pr-2 text-logo-second"
                />
                {agentEmail}{" "}
              </p>
            </div>
          </div>
          <div>
            <h1 className="text-4xl text-black pb-8 libre ">About Me</h1>

            {aboutContent ? (
              aboutContent.split("<|>").map((p) => (
                <p>
                  {p}
                  <br />
                  <br />
                </p>
              ))
            ) : (
              <p>Coming Soon</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
